'use client'

import { TrackerSection, TrackerSubSection } from '@/utils/tracker/shared'

import { HeadingTitleBlock } from '@/components/HeadingTitleBlock/HeadingTitleBlock'
import { DataIndukIcon } from '@/components/Icons/DataIndukIcon'

import { METATAG } from '@/configs/constants'

import { DATA_INDUK_LEVEL, DataIndukLevel } from './constant'
import { DataIndukKabKot } from './DataIndukKabKot'
import { DataIndukKecamatan } from './DataIndukKecamatan'
import { DataIndukNasional } from './DataIndukNasional'
import { DataIndukProvinsi } from './DataIndukProvinsi'

const COMPONENT_BY_LEVEL = {
  [DATA_INDUK_LEVEL.NASIONAL]: DataIndukNasional,
  [DATA_INDUK_LEVEL.PROVINSI]: DataIndukProvinsi,
  [DATA_INDUK_LEVEL.KAB_KOT]: DataIndukKabKot,
  [DATA_INDUK_LEVEL.KECAMATAN]: DataIndukKecamatan,
}

export default function DataIndukPage({ level }: { level: DataIndukLevel }) {
  const Component = COMPONENT_BY_LEVEL[level]

  return (
    <>
      <HeadingTitleBlock
        withIcon={true}
        withFaqText={true}
        withMapOverlay={true}
        icon={<DataIndukIcon />}
        title={METATAG.DATA_INDUK_SATPEN.title}
        desc={METATAG.DATA_INDUK_SATPEN.description}
        trackerGaEventName="induk"
        trackerPageTitle="Data Induk"
        trackerAdditionalParams={{
          section: TrackerSection.SATPEN,
          sub_section: TrackerSubSection.PAUD_DIKDASMEN,
        }}
      />
      <article>{Component ? <Component /> : null}</article>
    </>
  )
}
